var _linearGradient, _linearGradient2, _linearGradient3, _path, _g, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiPaymentsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECT",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch",
    gradientUnits: "userSpaceOnUse",
    x1: -4.4,
    x2: 32.7,
    y1: 16,
    y2: 16,
    "data-name": "New Gradient Swatch"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7738c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461d93"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-2",
    x2: 32.7,
    xlinkHref: "#New_Gradient_Swatch",
    y1: 13,
    y2: 13,
    "data-name": "New Gradient Swatch"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-5",
    xlinkHref: "#New_Gradient_Swatch",
    y1: 24,
    y2: 24,
    "data-name": "New Gradient Swatch"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30 10h-3v-5c0-.55-.45-1-1-1h-24c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h3v5c0 .55.45 1 1 1h24c.55 0 1-.45 1-1v-16c0-.55-.45-1-1-1zm-27-4h22v14h-22zm26 20h-22v-4h19c.55 0 1-.45 1-1v-9h2z",
    fill: "url(#New_Gradient_Swatch)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#New_Gradient_Swatch-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.25 11h3c.55 0 1-.45 1-1s-.45-1-1-1h-1.25v-.5c0-.55-.45-1-1-1s-1 .45-1 1v.53c-1.26.13-2.25 1.18-2.25 2.47 0 1.38 1.12 2.5 2.5 2.5h1.5c.28 0 .5.22.5.5s-.22.5-.5.5h-3c-.55 0-1 .45-1 1s.45 1 1 1h1.25v.5c0 .55.45 1 1 1s1-.45 1-1v-.53c1.26-.13 2.25-1.18 2.25-2.47 0-1.38-1.12-2.5-2.5-2.5h-1.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.5 12h-1c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1s-.45-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 12h-1c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1s-.45-1-1-1z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11 23h-1c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1s-.45-1-1-1z",
    fill: "url(#New_Gradient_Swatch-5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16 23h-1c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1s-.45-1-1-1z",
    fill: "url(#New_Gradient_Swatch-5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiPaymentsIcon);
export default __webpack_public_path__ + "static/media/multiPaymentsIcon.8a1fbe32266b090a4981eb4036e900c6.svg";
export { ForwardRef as ReactComponent };